import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CreateModelParams, Model } from '@web-portal/domains/shared/domain-models';

@Injectable()
export abstract class ModelsServiceStrategy<M = Model> {
  abstract getModelsForProject(projectId: string): Observable<M[]>;
  abstract createModel(params: CreateModelParams): Observable<M>;
  abstract deleteModel(modelId: string): Observable<unknown>;
  abstract renameModel(modelId: string, name: string): Observable<unknown>;
  abstract refreshModels(): Observable<M[]> | null;
  abstract getThumbnailUrl(modelId: string): string;
  abstract getDownloadUrl(modelId: string, revision: number): string;
}
